import React from 'react';
import { Form as FormikForm, Formik } from 'formik';
import validate from 'validate.js';
import classNames from 'classnames';

export default function Form({
    children,
    constraints,
    onSubmit: onSubmitHandler,
    validateOnChange,
    validateOnBlur,
    noMargin,
    data
}) {

    function validateForm(values) {

        if(!constraints) {
            return;
        }

        let errors = validate({...data, ...values}, constraints)

        if (errors) {
            const errorsList = Object.keys(errors)
            for (let i = 0; i < errorsList.length; i++) {
                const error = errorsList[i];
                const errorText = errors[error]?.[0];
                errors[error] = errorText;
            }
        }

        return errors;
    }

    const Classes = classNames({
        'flex flex-wrap': true,
        '-mx-2': !noMargin,
    })

    return (
        <Formik
            initialValues={data || {}}
            validate={validateForm}
            validateOnBlur={!!validateOnBlur}
            validateOnChange={!!validateOnChange}
            enableReinitialize
            onSubmit={(values, { setSubmitting }) => {
                setTimeout(() => {
                    onSubmitHandler(values)
                    setSubmitting(false);
                }, 400);
            }}
        >
            <FormikForm>
                <div className={Classes}>
                    {children}
                </div>
            </FormikForm>
        </Formik>
    )
}




